import type { ContentData } from '@/types/content';

const contentAr: ContentData = {
  common: {
    brandName: "معامل الهامى",
    fullBrandName: "معامل إلهامي لاب للتحاليل الطبية",
    fullBrandNameEn: "Elhamy Lab Medical Laboratories",
    home: "الرئيسية",
    about: "من نحن",
    services: "الخدمات",
    tests: "قاعدة البيانات",
    branches: "الفروع",
    blog: "المدونة",
    careers: "الوظائف",
    contact: "اتصل بنا",
    book: "احجز الآن",
    learnMore: "اعرف المزيد",
    readMore: "اقرأ المزيد",
    applyNow: "قدم الآن",
    sendMessage: "أرسل رسالة",
    getDirections: "احصل على الاتجاهات",
    back: "رجوع",
    search: "بحث",
    searchPlaceholder: "ابحث...",
    noResults: "لا توجد نتائج",
    all: "الكل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    address: "العنوان",
    name: "الاسم",
    yourName: "اسمك",
    yourEmail: "بريدك الإلكتروني",
    yourPhone: "رقم هاتفك",
    yourMessage: "رسالتك",
    submit: "إرسال",
    virtualTour: "جولة افتراضية",
    technology: "التكنولوجيا والمعدات",
    medicalProfiles: "البروفايلات الطبية",
    preparation: "التحضير",
    turnaround: "مدة النتيجة",
    includes: "يشمل",
    price: "السعر",
    category: "الفئة"
  },
  home: {
    hero: {
      title: "معامل الهامى للتحاليل الطبية",
      subtitle: "دقة. ثقة. رعاية.",
      description: "نقدم خدمات تحليل طبية متقدمة بأعلى معايير الجودة والدقة. نحن ملتزمون بتقديم أفضل رعاية صحية لعملائنا من خلال أحدث التقنيات وأكثرها تطوراً في مجال التحاليل الطبية.",
      cta: "احجز موعدك الآن"
    },
    services: {
      title: "خدماتنا المتميزة",
      subtitle: "نقدم مجموعة شاملة من خدمات التحاليل الطبية المتطورة لتلبية جميع احتياجاتك الصحية",
      bloodTests: "تحاليل الدم",
      hormonePanels: "لوحات الهرمونات",
      allergyTests: "تحاليل الحساسية",
      diabeticProfiles: "بروفايلات السكري",
      childrenLab: "معمل الأطفال",
      womensHealth: "صحة المرأة",
      corporateSolutions: "الحلول المؤسسية",
      homeVisits: "الزيارات المنزلية"
    },
    why: {
      title: "لماذا معامل الهامى؟",
      subtitle: "نتميز بالدقة والسرعة والجودة في كل ما نقدمه",
      accuracy: {
        title: "الدقة",
        description: "أعلى مستويات الدقة في التحاليل الطبية"
      },
      speed: {
        title: "سرعة النتائج",
        description: "نتائج سريعة دون المساس بالجودة"
      },
      certified: {
        title: "معتمد",
        description: "شهادات معترف بها دولياً"
      },
      equipment: {
        title: "معدات متطورة",
        description: "أحدث الأجهزة الطبية والتقنيات"
      },
      team: {
        title: "فريق خبير",
        description: "أطباء وفنيون ذوو خبرة عالية"
      },
      branches: {
        title: "فروع متعددة",
        description: "مواقع مريحة في جميع أنحاء المدينة"
      }
    },
    statistics: {
      title: "إحصائياتنا المتميزة",
      subtitle: "أرقام تتحدث عن نفسها وتؤكد جودة خدماتنا",
      patientsServed: "مريض تم خدمتهم",
      testsAvailable: "تحليل متاح",
      branchesCount: "فرع",
      accuracyRate: "نسبة الدقة"
    },
    appPromo: {
      title: "حمّل تطبيقنا الذكي",
      description: "احجز مواعيدك، اعرض نتائجك، وأدر سجلاتك الصحية أينما كنت. تجربة صحية متكاملة في جيبك.",
      appStore: "متجر التطبيقات",
      googlePlay: "جوجل بلاي"
    },
    testimonials: {
      title: "ماذا يقول عملاؤنا",
      patient: "مريض",
      items: [
        {
          id: 1,
          name: "أحمد محمد",
          content: "خدمة ممتازة ونتائج دقيقة جداً. أنصح به بشدة!",
          rating: 5
        },
        {
          id: 2,
          name: "فاطمة علي",
          content: "طاقم محترف ووقت استجابة سريع. راضية جداً!",
          rating: 5
        },
        {
          id: 3,
          name: "محمد حسن",
          content: "أفضل معمل في المدينة. نتائج دقيقة وخدمة رائعة.",
          rating: 5
        }
      ]
    },
    partners: {
      title: "شركاؤنا وشركات التأمين"
    },
    visitorCounter: {
      text: "انت الزائر رقم {count}"
    }
  },
  about: {
    title: "من نحن",
    subtitle: "معامل طبية رائدة بدقة ورعاية وابتكار",
    experience: "خبرة أكثر من 30 عاماً",
    specialization: "معامل تحاليل طبية وأمراض الدم والمناعة",
    mission: {
      title: "مهمتنا",
      description: "تقديم خدمات تحليل طبية دقيقة وموثوقة وفي الوقت المناسب تساهم في تحسين نتائج الرعاية الصحية لمرضانا."
    },
    vision: {
      title: "رؤيتنا",
      description: "أن نكون المعمل الطبي الرائد في المنطقة، معترف بنا للتميز والابتكار والرعاية الصحية للمرضى."
    },
    journey: {
      title: "رحلتنا",
      founded: {
        year: "1994",
        title: "البداية",
        description: "انطلقت معامل إلهامي لتقديم خدمات معامل طبية عالية الجودة منذ عام 1994"
      },
      expansion: {
        year: "2015",
        title: "التوسع",
        description: "فتحنا فروع متعددة في جميع أنحاء المدينة"
      },
      digital: {
        year: "2020",
        title: "التحول الرقمي",
        description: "إطلاق التطبيق المحمول والخدمات الإلكترونية"
      },
      innovation: {
        year: "2024",
        title: "الابتكار",
        description: "قيادة الصناعة بتقنيات متقدمة"
      },
      rewrite: {
        year: "2025",
        title: "إعادة الانطلاق",
        titleEn: "Brand Rewrite",
        description: "أعدنا صياغة هويتنا وقنواتنا الرقمية لنقدم تجربة أكثر وضوحاً ودفئاً لعملائنا.",
        descriptionEn: "We refreshed our brand story and digital touchpoints to deliver a clearer, warmer experience for our patients."
      }
    },
    values: {
      title: "قيمنا",
      excellence: {
        title: "التميز",
        description: "نسعى للتميز في كل تحليل نقوم به"
      },
      accuracy: {
        title: "الدقة",
        description: "الدقة والصحة هي أولوياتنا القصوى"
      },
      transparency: {
        title: "الشفافية",
        description: "تواصل واضح ونتائج صادقة"
      },
      care: {
        title: "الرعاية",
        description: "رعاية المرضى في قلب كل ما نقوم به"
      }
    }
  },
  services: {
    title: "خدماتنا",
    subtitle: "خدمات معامل طبية شاملة مصممة خصيصاً لاحتياجاتك",
    backToServices: "العودة إلى الخدمات",
    aboutService: {
      title: "عن هذه الخدمة",
      description: "خدمة {serviceName} لدينا توفر اختبارات وتحليلات شاملة باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا.",
      description2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك."
    },
    keyFeatures: {
      title: "المميزات الرئيسية",
      accurate: "نتائج دقيقة وموثوقة",
      fast: "وقت استجابة سريع",
      professional: "طاقم طبي محترف",
      equipment: "معدات حديثة",
      reporting: "تقارير شاملة"
    },
    "blood-tests": {
      name: "تحاليل الدم",
      shortDescription: "تحاليل دم شاملة ودقيقة",
      heroDescription: "نقدم مجموعة شاملة من تحاليل الدم باستخدام أحدث التقنيات والمعدات الطبية المتطورة لضمان دقة النتائج وموثوقيتها.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة تحاليل الدم لدينا توفر اختبارات وتحليلات شاملة باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا. يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك.",
      aboutDescription2: "نقدم مجموعة واسعة من تحاليل الدم تشمل صورة الدم الكاملة، وظائف الكبد والكلى، الدهون، السكر، والعديد من التحاليل الأخرى. جميع التحاليل تتم في بيئة معقمة ومعتمدة وفقاً لأعلى المعايير الطبية الدولية.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "نتائج دقيقة وموثوقة",
          "وقت استجابة سريع",
          "طاقم طبي محترف",
          "معدات حديثة",
          "تقارير شاملة"
        ]
      }
    },
    "hormone-panels": {
      name: "الهرمونات",
      shortDescription: "فحص شامل للهرمونات",
      heroDescription: "خدمات فحص الهرمونات المتخصصة لتقييم الصحة الهرمونية الشاملة باستخدام أحدث التقنيات التشخيصية.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة فحص الهرمونات لدينا توفر تحليلاً شاملاً للوظائف الهرمونية في الجسم. نستخدم أحدث التقنيات والمعدات الطبية لضمان دقة النتائج وموثوقيتها. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم فحوصات شاملة للهرمونات تشمل هرمونات الغدة الدرقية، الهرمونات الجنسية، هرمونات النمو، والعديد من الهرمونات الأخرى المهمة.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "فحص شامل للهرمونات",
          "نتائج دقيقة وموثوقة",
          "تفسير طبي مفصل",
          "معدات متطورة",
          "تقارير شاملة"
        ]
      }
    },
    "allergy-tests": {
      name: "فحص الحساسية",
      shortDescription: "اختبارات الحساسية المتقدمة",
      heroDescription: "خدمات فحص الحساسية المتقدمة لتحديد مسببات الحساسية بدقة باستخدام أحدث التقنيات التشخيصية.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة فحص الحساسية لدينا توفر اختبارات وتحليلات شاملة لتحديد مسببات الحساسية باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم فحوصات شاملة للحساسية تشمل حساسية الطعام، حساسية البيئة، حساسية الأدوية، والعديد من أنواع الحساسية الأخرى.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "فحص شامل لأنواع الحساسية",
          "نتائج دقيقة وموثوقة",
          "تحديد دقيق لمسببات الحساسية",
          "معدات حديثة",
          "توصيات علاجية"
        ]
      }
    },
    "diabetic-profiles": {
      name: "ملفات السكري",
      shortDescription: "فحوصات شاملة لمرضى السكري",
      heroDescription: "برامج فحص شاملة ومتابعة دقيقة لمرضى السكري باستخدام أحدث التقنيات التشخيصية.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة ملفات السكري لدينا توفر فحوصات وتحليلات شاملة لمرضى السكري باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم فحوصات شاملة تشمل سكر الصائم، الهيموجلوبين السكري، الدهون، وظائف الكلى، وفحوصات أخرى مهمة لمرضى السكري.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "فحص شامل لمرضى السكري",
          "متابعة دورية",
          "نتائج دقيقة وموثوقة",
          "تفسير طبي مفصل",
          "توصيات علاجية"
        ]
      }
    },
    "children-lab": {
      name: "مختبر الأطفال",
      shortDescription: "خدمات مختبرية متخصصة للأطفال",
      heroDescription: "خدمات مختبرية متخصصة وآمنة للأطفال مع بيئة مريحة وطاقم طبي مدرب خصيصاً للتعامل مع الأطفال.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة مختبر الأطفال لدينا توفر خدمات مختبرية متخصصة وآمنة للأطفال باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا الصغار.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم بيئة مريحة وآمنة للأطفال مع طاقم طبي مدرب خصيصاً للتعامل مع الأطفال بطريقة لطيفة ومريحة.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "بيئة مريحة للأطفال",
          "طاقم طبي متخصص",
          "نتائج دقيقة وموثوقة",
          "تقنيات آمنة",
          "تقارير شاملة"
        ]
      }
    },
    "womens-health": {
      name: "صحة المرأة",
      shortDescription: "فحوصات صحية متخصصة للنساء",
      heroDescription: "خدمات فحص صحية متخصصة للنساء مع تركيز على الصحة الإنجابية والهرمونية باستخدام أحدث التقنيات.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة صحة المرأة لدينا توفر فحوصات وتحليلات شاملة ومتخصصة للنساء باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مريضاتنا.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم فحوصات شاملة تشمل فحوصات الهرمونات النسائية، فحوصات الحمل، فحوصات الغدة الدرقية، والعديد من الفحوصات الأخرى المهمة لصحة المرأة.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "فحوصات متخصصة للنساء",
          "نتائج دقيقة وموثوقة",
          "خصوصية كاملة",
          "طاقم طبي نسائي",
          "تقارير شاملة"
        ]
      }
    },
    "corporate-solutions": {
      name: "الحلول المؤسسية",
      shortDescription: "خدمات مختبرية للشركات",
      heroDescription: "حلول مختبرية شاملة للشركات والمؤسسات مع برامج صحية مخصصة وخدمات متكاملة.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة الحلول المؤسسية لدينا توفر خدمات مختبرية شاملة للشركات والمؤسسات باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع موظفيكم.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدكم بتقارير مفصلة وتفسيرات واضحة للنتائج. نقدم برامج صحية مخصصة للشركات تشمل فحوصات دورية، فحوصات ما قبل التوظيف، فحوصات السلامة المهنية، والعديد من الخدمات الأخرى.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "برامج صحية مخصصة",
          "خدمات متكاملة",
          "نتائج دقيقة وموثوقة",
          "تقارير إدارية",
          "أسعار تنافسية"
        ]
      }
    },
    "home-visits": {
      name: "الزيارات المنزلية",
      shortDescription: "خدمة سحب عينات من المنزل",
      heroDescription: "خدمة سحب عينات من المنزل مع طاقم طبي محترف وموثوق لراحتك وسهولة الوصول.",
      aboutTitle: "عن هذه الخدمة",
      aboutDescription: "خدمة الزيارات المنزلية لدينا توفر خدمة سحب عينات من المنزل باستخدام أحدث التقنيات والمعدات الطبية. نضمن الدقة والموثوقية والنتائج في الوقت المناسب لجميع مرضانا.",
      aboutDescription2: "يعمل أطباؤنا ذوو الخبرة بجد لتزويدك بتقارير مفصلة وتفسيرات واضحة لنتائجك. نقدم خدمة مريحة وآمنة مع طاقم طبي محترف ومدرب يزورك في منزلك في الوقت المحدد لسحب العينات.",
      keyFeatures: {
        title: "المميزات الرئيسية",
        items: [
          "خدمة منزلية مريحة",
          "طاقم طبي محترف",
          "نتائج دقيقة وموثوقة",
          "حجز سهل",
          "توصيل النتائج"
        ]
      }
    }
  },
  tests: {
    title: "قاعدة بيانات التحاليل",
    subtitle: "ابحث في قاعدة بياناتنا الشاملة للتحاليل الطبية",
    searchPlaceholder: "ابحث عن التحاليل...",
    noTestsFound: "لم يتم العثور على تحاليل تطابق معاييرك",
    categories: {
      all: "الكل",
      bloodTests: "تحاليل الدم",
      hormoneTests: "تحاليل الهرمونات",
      allergyTests: "تحاليل الحساسية",
      other: "أخرى"
    }
  },
  branches: {
    title: "فروعنا",
    subtitle: "اعثر على فرعنا الأقرب إليك",
    whatsapp: "واتساب",
    hours: "ساعات العمل"
  },
  blog: {
    title: "المدونة",
    subtitle: "رؤى صحية، أخبار طبية، ومحتوى تعليمي",
    searchPlaceholder: "ابحث في المدونة...",
    filterByCategory: "تصفية حسب الفئة",
    allCategories: "جميع الفئات",
    noPostsFound: "لم يتم العثور على مقالات",
    author: "المؤلف",
    publishedOn: "نُشر في",
    readTime: "دقيقة قراءة",
    relatedPosts: "مقالات ذات صلة",
    shareCta: "لمعرفة المزيد فقط قم بزيارة",
    categories: {
      healthEducation: "التعليم الصحي",
      preventiveCare: "الرعاية الوقائية",
      chronicDisease: "الأمراض المزمنة",
      womensHealth: "صحة المرأة"
    },
    posts: [
      {
        id: 1,
        title: "فهم نتائج تحاليل الدم",
        excerpt: "تعلم كيفية قراءة وفهم نتائج تحاليل الدم وما تعنيه لصحتك. دليل شامل لمساعدتك على فهم تقاريرك الطبية.",
        author: "د. أحمد محمد",
        date: "2024-01-15",
        category: "healthEducation",
        readTime: 5,
        image: "/assets/images/red-blood-cells.jpeg",
        content: [
          "تحاليل الدم هي واحدة من أكثر الفحوصات الطبية شيوعاً وأهمية. تساعد هذه التحاليل في تشخيص العديد من الحالات الصحية ومراقبة فعالية العلاج. في هذا المقال، سنتعلم كيفية قراءة وفهم نتائج تحاليل الدم بشكل صحيح.",
          "صورة الدم الكاملة (CBC) هي من أكثر التحاليل شيوعاً. تقيس هذه التحاليل عدد خلايا الدم الحمراء والبيضاء والصفائح الدموية. المستويات الطبيعية تشير إلى صحة جيدة، بينما المستويات غير الطبيعية قد تشير إلى حالات مثل فقر الدم أو العدوى.",
          "وظائف الكبد والكلى هي أيضاً جزء مهم من تحاليل الدم. هذه التحاليل تساعد في تقييم صحة هذه الأعضاء الحيوية. المستويات المرتفعة قد تشير إلى مشاكل في الكبد أو الكلى.",
          "من المهم أن تتذكر أن نتائج التحاليل يجب أن تُفسر من قبل طبيب مختص. لا تحاول تشخيص نفسك بناءً على النتائج فقط. استشر طبيبك دائماً للحصول على تفسير صحيح وخطة علاج مناسبة."
        ]
      },
      {
        id: 2,
        title: "أهمية الفحوصات الصحية الدورية",
        excerpt: "يمكن أن تساعد الفحوصات الصحية الدورية في اكتشاف المشاكل الصحية مبكراً وتحسين نتائج العلاج. اكتشف متى وكيف يجب إجراء الفحوصات.",
        author: "د. فاطمة علي",
        date: "2024-01-10",
        category: "preventiveCare",
        readTime: 7,
        image: "/assets/images/freepik__talk.jpeg",
        content: [
          "الفحوصات الصحية الدورية هي مفتاح الحفاظ على صحتك والوقاية من الأمراض. تساعد هذه الفحوصات في اكتشاف المشاكل الصحية في مراحلها المبكرة، عندما يكون العلاج أكثر فعالية.",
          "يُنصح بإجراء فحص صحي شامل مرة واحدة على الأقل سنوياً للبالغين. يجب أن يشمل هذا الفحص قياس ضغط الدم، فحص الدم، وفحوصات أخرى حسب العمر والجنس والتاريخ الطبي.",
          "للأشخاص الذين تزيد أعمارهم عن 40 عاماً، يُنصح بإجراء فحوصات أكثر تواتراً. يجب أيضاً إجراء فحوصات خاصة للنساء والرجال حسب التوصيات الطبية.",
          "تذكر أن الوقاية خير من العلاج. الفحوصات الدورية لا تكلف الكثير مقارنة بالعلاج من الأمراض المتقدمة. استثمر في صحتك من خلال إجراء الفحوصات بانتظام."
        ]
      },
      {
        id: 3,
        title: "إدارة مرض السكري من خلال التحاليل الطبية",
        excerpt: "كيف يمكن للتحاليل الطبية المنتظمة أن تساعد في إدارة مرض السكري ومنع المضاعفات. دليل شامل لمرضى السكري.",
        author: "د. محمد حسن",
        date: "2024-01-05",
        category: "chronicDisease",
        readTime: 6,
        image: "/assets/images/freepik__upload.jpeg",
        content: [
          "مرض السكري هو حالة مزمنة تتطلب مراقبة مستمرة وإدارة دقيقة. التحاليل الطبية المنتظمة هي جزء أساسي من خطة إدارة مرض السكري الناجحة.",
          "فحص سكر الدم الصائم (FBS) وفحص الهيموجلوبين السكري (HbA1c) هما من أهم التحاليل لمرضى السكري. يساعد HbA1c في تقييم متوسط مستويات السكر في الدم على مدى 2-3 أشهر الماضية.",
          "من المهم أيضاً مراقبة وظائف الكلى والدهون بانتظام، حيث أن مرضى السكري معرضون لخطر متزايد من مشاكل الكلى وأمراض القلب. يجب إجراء هذه الفحوصات كل 3-6 أشهر حسب توصيات الطبيب.",
          "الالتزام بجدول الفحوصات المنتظمة يساعد في اكتشاف أي مشاكل مبكراً واتخاذ الإجراءات المناسبة. تذكر أن إدارة مرض السكري بنجاح تتطلب تعاوناً وثيقاً مع فريق الرعاية الصحية الخاص بك."
        ]
      },
      {
        id: 4,
        title: "صحة المرأة: التحاليل الأساسية",
        excerpt: "التحاليل الطبية المهمة التي يجب أن تفكر فيها كل امرأة للحفاظ على صحتها المثلى. دليل شامل لصحة المرأة.",
        author: "د. سارة إبراهيم",
        date: "2024-01-01",
        category: "womensHealth",
        readTime: 8,
        image: "/assets/images/3d-cartoon-style-character.jpeg",
        content: [
          "صحة المرأة تتطلب اهتماماً خاصاً وفحوصات منتظمة لضمان الرفاهية العامة. هناك العديد من التحاليل المهمة التي يجب على كل امرأة التفكير فيها في مراحل مختلفة من حياتها.",
          "فحوصات الهرمونات النسائية مهمة بشكل خاص للنساء في سن الإنجاب. تساعد هذه الفحوصات في تقييم الصحة الإنجابية وتشخيص أي مشاكل هرمونية قد تؤثر على الخصوبة أو الصحة العامة.",
          "فحص وظائف الغدة الدرقية مهم أيضاً للنساء، حيث أن اضطرابات الغدة الدرقية أكثر شيوعاً لدى النساء. يجب إجراء هذا الفحص بانتظام، خاصة إذا كانت هناك أعراض مثل التعب أو تغيرات في الوزن.",
          "فحص فيتامين د والكالسيوم مهمان لصحة العظام، خاصة مع تقدم العمر. النساء معرضات بشكل خاص لهشاشة العظام، لذا من المهم مراقبة مستويات هذه الفيتامينات والمعادن.",
          "تذكري أن الوقاية والفحوصات المنتظمة هي مفتاح الحفاظ على صحتك. استشيري طبيبك لتحديد جدول الفحوصات المناسب لعمرك وتاريخك الطبي."
        ]
      },
      {
        id: 5,
        title: "ماذا تعني نتائج الكوليسترول؟",
        excerpt: "دليل شامل لفهم نتائج تحاليل الكوليسترول والدهون، وكيفية الحفاظ على مستويات صحية من خلال النظام الغذائي ونمط الحياة.",
        author: "د. خالد محمود",
        date: "2023-12-28",
        category: "healthEducation",
        readTime: 6,
        image: "/assets/images/istockphoto.jpeg",
        content: [
          "الكوليسترول هو مادة دهنية موجودة في الدم وضرورية لصحة الجسم. ومع ذلك، فإن المستويات المرتفعة من الكوليسترول يمكن أن تزيد من خطر الإصابة بأمراض القلب والأوعية الدموية. فهم نتائج تحاليل الكوليسترول يساعدك على اتخاذ قرارات صحية مستنيرة.",
          "تحليل الدهون الشامل (Lipid Profile) يقيس عدة أنواع من الدهون في الدم: الكوليسترول الكلي (Total Cholesterol)، الكوليسترول الضار (LDL)، الكوليسترول النافع (HDL)، والدهون الثلاثية (Triglycerides). كل نوع له دور مهم في صحة القلب.",
          "الكوليسترول الضار (LDL) يجب أن يكون أقل من 100 ملغ/ديسيلتر للأشخاص الأصحاء، وأقل من 70 ملغ/ديسيلتر للأشخاص المعرضين لخطر الإصابة بأمراض القلب. الكوليسترول النافع (HDL) يجب أن يكون أعلى من 40 ملغ/ديسيلتر للرجال و50 ملغ/ديسيلتر للنساء.",
          "يمكنك تحسين مستويات الكوليسترول من خلال: تناول نظام غذائي صحي غني بالفواكه والخضروات والحبوب الكاملة، ممارسة التمارين الرياضية بانتظام، الحفاظ على وزن صحي، وتجنب التدخين. في بعض الحالات، قد يوصي الطبيب بالأدوية لخفض الكوليسترول.",
          "من المهم إجراء فحص الكوليسترول بانتظام، خاصة إذا كان لديك تاريخ عائلي من أمراض القلب أو عوامل خطر أخرى. استشر طبيبك لتحديد جدول الفحوصات المناسب لك."
        ]
      },
      {
        id: 6,
        title: "فحص وظائف الكبد والكلى: دليل شامل",
        excerpt: "تعرف على أهمية فحوصات وظائف الكبد والكلى، ومتى يجب إجراؤها، وكيفية تفسير النتائج للحفاظ على صحة هذه الأعضاء الحيوية.",
        author: "د. نورا أحمد",
        date: "2023-12-25",
        category: "preventiveCare",
        readTime: 7,
        image: "/assets/images/human.png",
        content: [
          "الكبد والكلى هما من أهم الأعضاء في الجسم، حيث يلعبان أدواراً حيوية في إزالة السموم، تنظيم السوائل، وإنتاج البروتينات المهمة. فحوصات وظائف هذه الأعضاء تساعد في اكتشاف المشاكل مبكراً قبل أن تصبح خطيرة.",
          "فحص وظائف الكبد يقيس مستويات إنزيمات الكبد مثل ALT وAST، والبيليروبين، والألبومين. المستويات المرتفعة من هذه الإنزيمات قد تشير إلى التهاب الكبد، تلف الكبد، أو مشاكل أخرى. من المهم ملاحظة أن بعض الأدوية والكحول يمكن أن تؤثر على نتائج هذه الفحوصات.",
          "فحص وظائف الكلى يقيس مستويات الكرياتينين واليوريا في الدم. الكرياتينين هو منتج نفايات يتم إنتاجه من العضلات ويتم تصفيته من الدم عن طريق الكلى. المستويات المرتفعة قد تشير إلى مشاكل في وظائف الكلى. كما يقيس الفحص معدل الترشيح الكبيبي (eGFR) الذي يعطي مؤشراً دقيقاً على كفاءة عمل الكلى.",
          "يُنصح بإجراء فحوصات وظائف الكبد والكلى: كجزء من الفحص الصحي السنوي، قبل البدء في تناول أدوية جديدة قد تؤثر على هذه الأعضاء، إذا كان لديك تاريخ عائلي من أمراض الكبد أو الكلى، أو إذا كنت تعاني من أعراض مثل التعب، اصفرار الجلد، أو تورم في الساقين.",
          "الحفاظ على صحة الكبد والكلى يتطلب: شرب كميات كافية من الماء، اتباع نظام غذائي صحي، تجنب الإفراط في تناول الكحول، ممارسة التمارين الرياضية بانتظام، وتجنب الأدوية التي قد تضر بهذه الأعضاء إلا تحت إشراف طبي."
        ]
      },
      {
        id: 7,
        title: "التحضير للتحاليل الطبية: نصائح مهمة",
        excerpt: "تعلم كيفية التحضير بشكل صحيح للتحاليل الطبية لضمان الحصول على نتائج دقيقة. دليل شامل للتحضير قبل التحاليل.",
        author: "د. يوسف عبدالله",
        date: "2023-12-20",
        category: "healthEducation",
        readTime: 5,
        image: "/assets/images/pexels.png",
        content: [
          "التحضير الصحيح للتحاليل الطبية أمر بالغ الأهمية للحصول على نتائج دقيقة وموثوقة. النتائج غير الدقيقة قد تؤدي إلى تشخيص خاطئ أو علاج غير مناسب. اتباع التعليمات الطبية بدقة يضمن أفضل النتائج.",
          "للتحاليل التي تتطلب الصيام (مثل سكر الدم الصائم، الكوليسترول، وظائف الكبد): يجب الصيام لمدة 8-12 ساعة قبل الفحص. خلال فترة الصيام، يمكنك شرب الماء فقط، ولكن يجب تجنب الطعام، المشروبات المحلاة، القهوة، والشاي. إذا كنت تتناول أدوية، استشر طبيبك حول ما إذا كان يجب تناولها قبل الفحص أم لا.",
          "للتحاليل العامة: يمكنك تناول الطعام والشراب بشكل طبيعي، ولكن يُنصح بتجنب الوجبات الدسمة قبل الفحص مباشرة. ارتدِ ملابس فضفاضة لتسهيل سحب العينة، خاصة من الذراع. أخبر الفني إذا كنت تشعر بالقلق أو الدوار.",
          "قبل الفحص: احصل على قسط كافٍ من النوم، تجنب التمارين الرياضية الشاقة قبل 24 ساعة من الفحص، تجنب الكحول لمدة 24 ساعة قبل الفحص، وأخبر طبيبك عن جميع الأدوية والمكملات الغذائية التي تتناولها.",
          "إذا نسيت التعليمات أو لم تفهمها بشكل كامل، لا تتردد في الاتصال بالمعمل أو طبيبك للتوضيح. التحضير الصحيح يوفر الوقت والمال ويضمن الحصول على نتائج دقيقة تساعد في التشخيص والعلاج الصحيح."
        ]
      },
      {
        id: 8,
        title: "فحص الهرمونات: متى ولماذا؟",
        excerpt: "دليل شامل لفهم أهمية فحوصات الهرمونات، ومتى يجب إجراؤها، وكيف يمكن أن تساعد في تشخيص المشاكل الصحية المختلفة.",
        author: "د. مريم سعيد",
        date: "2023-12-15",
        category: "womensHealth",
        readTime: 6,
        image: "/assets/images/sex-education.png",
        content: [
          "الهرمونات هي رسائل كيميائية تنتقل عبر الدم لتنظيم وظائف الجسم المختلفة. أي خلل في مستويات الهرمونات يمكن أن يؤثر على الصحة العامة، المزاج، الطاقة، والوظائف الإنجابية. فحوصات الهرمونات تساعد في تحديد المشاكل وعلاجها.",
          "للنساء، فحوصات الهرمونات مهمة بشكل خاص في حالات: عدم انتظام الدورة الشهرية، صعوبة الحمل، أعراض انقطاع الطمث، مشاكل البشرة والشعر، تغيرات المزاج، أو زيادة الوزن غير المبررة. الهرمونات النسائية الرئيسية التي يتم فحصها تشمل الإستروجين، البروجسترون، هرمون FSH، وهرمون LH.",
          "هرمونات الغدة الدرقية (TSH، T3، T4) مهمة لجميع الأشخاص. خلل الغدة الدرقية شائع جداً ويمكن أن يسبب أعراضاً مثل التعب، زيادة أو نقصان الوزن، تساقط الشعر، وتغيرات في المزاج. يُنصح بفحص وظائف الغدة الدرقية كجزء من الفحص الصحي الروتيني.",
          "هرمون الكورتيزول (هرمون الإجهاد) يمكن فحصه إذا كنت تعاني من التعب المزمن، صعوبة النوم، أو أعراض أخرى للإجهاد. هرمونات النمو والأنسولين قد يتم فحصها في حالات محددة بناءً على الأعراض والتاريخ الطبي.",
          "يجب إجراء فحص الهرمونات في وقت محدد من الدورة الشهرية للنساء (عادة في اليوم الثالث من الدورة). استشر طبيبك حول أفضل وقت لإجراء الفحص. النتائج الطبيعية تختلف حسب العمر، الجنس، ومرحلة الحياة، لذا من المهم أن يفسر الطبيب النتائج في سياق حالتك الصحية العامة."
        ]
      },
      {
        id: 9,
        title: "فحص الحساسية: أنواعه وأهميته",
        excerpt: "تعرف على أنواع فحوصات الحساسية المختلفة، ومتى يجب إجراؤها، وكيف يمكن أن تساعد في تحديد مسببات الحساسية.",
        author: "د. عمرو إسماعيل",
        date: "2023-12-10",
        category: "preventiveCare",
        readTime: 5,
        image: "/assets/images/coronavirus.png",
        content: [
          "الحساسية هي استجابة مفرطة من الجهاز المناعي لمواد عادية غير ضارة. يمكن أن تسبب الحساسية أعراضاً مزعجة مثل العطس، الحكة، الطفح الجلدي، أو في الحالات الشديدة، صعوبة في التنفس. فحوصات الحساسية تساعد في تحديد المواد المسببة للحساسية (مسببات الحساسية) حتى يمكن تجنبها أو علاجها.",
          "هناك عدة أنواع من فحوصات الحساسية: فحص الجلد (Skin Prick Test) حيث يتم وضع قطرات صغيرة من مسببات الحساسية على الجلد ومراقبة التفاعل، فحص الدم (RAST أو ImmunoCAP) الذي يقيس مستويات الأجسام المضادة IgE في الدم، وفحص التحدي الغذائي الذي يتم تحت إشراف طبي.",
          "فحص الدم للحساسية مفيد بشكل خاص للأشخاص الذين: يعانون من حالات جلدية تجعل فحص الجلد صعباً، يتناولون أدوية قد تتداخل مع نتائج فحص الجلد، أو لديهم تاريخ من ردود فعل تحسسية شديدة. هذا النوع من الفحوصات آمن ويمكن إجراؤه في أي وقت.",
          "من المهم إجراء فحص الحساسية إذا كنت تعاني من: أعراض مستمرة مثل العطس، سيلان الأنف، أو حكة في العينين، طفح جلدي أو أكزيما، أعراض هضمية بعد تناول أطعمة معينة، أو صعوبة في التنفس بعد التعرض لمواد معينة. تحديد مسببات الحساسية يساعد في تجنبها وتقليل الأعراض.",
          "بعد تحديد مسببات الحساسية، يمكنك: تجنب المواد المسببة للحساسية، استخدام الأدوية المضادة للحساسية عند الحاجة، أو التفكير في العلاج المناعي (Immunotherapy) في الحالات الشديدة. استشر طبيب الحساسية لتحديد أفضل خطة علاج لك."
        ]
      },
      {
        id: 10,
        title: "إدارة ارتفاع ضغط الدم من خلال التحاليل",
        excerpt: "كيف يمكن للتحاليل الطبية المنتظمة أن تساعد في مراقبة وإدارة ارتفاع ضغط الدم، ومنع المضاعفات الخطيرة.",
        author: "د. هالة محسن",
        date: "2023-12-05",
        category: "chronicDisease",
        readTime: 7,
        image: "/assets/images/realistic-world.png",
        content: [
          "ارتفاع ضغط الدم (Hypertension) هو حالة شائعة تؤثر على ملايين الأشخاص حول العالم. إذا لم يتم علاجه، يمكن أن يؤدي إلى مشاكل صحية خطيرة مثل أمراض القلب، السكتة الدماغية، وأمراض الكلى. التحاليل الطبية المنتظمة هي جزء أساسي من إدارة ارتفاع ضغط الدم بنجاح.",
          "عند تشخيص ارتفاع ضغط الدم، يوصي الأطباء عادة بإجراء مجموعة من التحاليل لتقييم الصحة العامة وتحديد أي مضاعفات محتملة. هذه التحاليل تشمل: فحص البول للتحقق من وجود بروتين أو دم، فحص الدم الشامل، فحص وظائف الكلى، فحص وظائف الكبد، فحص الكوليسترول والدهون، وفحص سكر الدم.",
          "فحص وظائف الكلى مهم بشكل خاص لمرضى ارتفاع ضغط الدم، حيث أن ارتفاع ضغط الدم يمكن أن يسبب تلف الكلى، والكلى التالفة يمكن أن تزيد من ارتفاع ضغط الدم. يتم فحص مستويات الكرياتينين واليوريا في الدم، ومعدل الترشيح الكبيبي (eGFR) لتقييم صحة الكلى.",
          "فحص القلب والأوعية الدموية قد يشمل أيضاً تخطيط القلب (ECG) وفحص العين للتحقق من أي تغيرات في الأوعية الدموية. هذه الفحوصات تساعد في اكتشاف أي ضرر قد يكون قد حدث بالفعل بسبب ارتفاع ضغط الدم.",
          "بعد البدء في العلاج، يجب إجراء فحوصات دورية كل 3-6 أشهر لمراقبة: فعالية الأدوية، أي آثار جانبية محتملة، صحة الكلى والقلب، ومستويات الدهون والسكر في الدم. الالتزام بجدول الفحوصات المنتظمة يساعد في ضمان أن العلاج يعمل بشكل صحيح وأن صحتك العامة محمية.",
          "إلى جانب التحاليل الطبية، من المهم أيضاً: قياس ضغط الدم بانتظام في المنزل، اتباع نظام غذائي صحي قليل الملح، ممارسة التمارين الرياضية بانتظام، الحفاظ على وزن صحي، تجنب التدخين، وتقليل التوتر. هذه التغييرات في نمط الحياة، جنباً إلى جنب مع التحاليل المنتظمة، تساعد في إدارة ارتفاع ضغط الدم بنجاح."
        ]
      }
    ]
  },
  careers: {
    title: "الوظائف",
    subtitle: "انضم إلى فريقنا واصنع فرقاً في الرعاية الصحية",
    openPositions: "الوظائف المتاحة",
    department: "القسم",
    location: "الموقع",
    type: "النوع",
    fullTime: "دوام كامل",
    partTime: "دوام جزئي"
  },
  contact: {
    title: "اتصل بنا",
    subtitle: "تواصل معنا. نحن هنا لمساعدتك.",
    contactInfo: {
      title: "معلومات الاتصال",
      phone: "الهاتف",
      phone1: "010 0607 6325",
      phone2: "040 221 2255",
      phone3: "040 221 3030",
      email: "البريد الإلكتروني",
      address: "العنوان",
      fullAddress: "شارع 23 يوليو (شارع البحر سابقاً)، عمارة بركات، بجوار سينما المحلة، مدينة المحلة الكبرى، محافظة الغربية، مصر"
    },
    sendMessage: {
      title: "أرسل لنا رسالة",
      namePlaceholder: "اسمك", 
      messagePlaceholder: "رسالتك",
      successMessage: "شكراً لرسالتك! سنتواصل معك قريباً."
    }
  },
  virtualTour: {
    title: "جولة افتراضية في المعمل",
    subtitle: "قم بجولة افتراضية في مرافقنا المتطورة",
    reception: {
      title: "منطقة الاستقبال",
      description: "مرحباً بكم في منطقة الاستقبال العصرية لدينا"
    },
    laboratory: {
      title: "المعمل",
      description: "مرافق معملية متطورة بأحدث التقنيات"
    },
    sampleCollection: {
      title: "جمع العينات",
      description: "غرف مريحة لجمع العينات"
    },
    analysisRoom: {
      title: "غرفة التحليل",
      description: "معدات تحليل واختبار متقدمة"
    },
    waitingArea: {
      title: "منطقة الانتظار",
      description: "مناطق انتظار مريحة للمرضى"
    },
    qualityControl: {
      title: "مراقبة الجودة",
      description: "قسم مراقبة وضمان الجودة"
    }
  },
  technology: {
    title: "التكنولوجيا والمعدات",
    subtitle: "تقنيات متطورة لنتائج دقيقة وموثوقة",
    automatedAnalyzer: {
      title: "محلل آلي",
      description: "نظام تحليل دم آلي متطور للحصول على نتائج دقيقة وسريعة"
    },
    digitalImaging: {
      title: "التصوير الرقمي",
      description: "تقنية تصوير رقمية متقدمة لتحليل العينات بدقة"
    },
    qualityControl: {
      title: "أنظمة مراقبة الجودة",
      description: "أنظمة مراقبة جودة شاملة تضمن الدقة والموثوقية"
    },
    highSpeed: {
      title: "معالجة عالية السرعة",
      description: "وحدات معالجة عالية السرعة لنتائج سريعة دون المساس بالجودة"
    },
    workflow: {
      title: "سير عملنا",
      sampleCollection: {
        title: "جمع العينات",
        description: "جمع عينات احترافي"
      },
      processing: {
        title: "المعالجة",
        description: "معالجة وتحليل آلي"
      },
      qualityControl: {
        title: "مراقبة الجودة",
        description: "فحوصات جودة صارمة"
      },
      results: {
        title: "النتائج",
        description: "نتائج دقيقة وفي الوقت المناسب"
      }
    }
  },
  medicalProfiles: {
    title: "البروفايلات الطبية",
    subtitle: "حزم فحص صحي شاملة مصممة خصيصاً لاحتياجاتك",
    searchPlaceholder: "ابحث عن البروفايلات...",
    completeHealth: {
      title: "فحص صحي شامل",
      description: "تقييم صحي شامل يشمل تحاليل الدم ووظائف الكبد والكلى",
      tests: ["صورة دم كاملة", "وظائف الكبد", "وظائف الكلى", "الدهون"]
    },
    diabetes: {
      title: "بروفايل السكري",
      description: "بروفايل شامل لمراقبة وإدارة السكري",
      tests: ["سكر صائم", "الهيموجلوبين السكري", "الدهون", "وظائف الكلى"]
    },
    cardiac: {
      title: "بروفايل القلب",
      description: "تقييم صحة القلب وتقييم مخاطر القلب والأوعية الدموية",
      tests: ["الدهون", "إنزيمات القلب", "صورة دم كاملة", "وظائف الكلى"]
    },
    womensHealth: {
      title: "بروفايل صحة المرأة",
      description: "فحص شامل لصحة المرأة",
      tests: ["لوحة الهرمونات", "وظائف الغدة الدرقية", "صورة دم كاملة", "فيتامين د"]
    },
    preparation: {
      fasting12: "صيام 12 ساعة",
      noPreparation: "لا يوجد تحضير خاص"
    }
  },
  footer: {
    copyright: "جميع الحقوق محفوظة",
    builtBy: "تم تصميم وتطوير هذا النظام بواسطة فريق",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    phone1: "010 0607 6325",
    phone2: "040 221 2255",
    phone3: "040 221 3030",
    address: "شارع 23 يوليو (شارع البحر سابقاً)، عمارة بركات، بجوار سينما المحلة، مدينة المحلة الكبرى، محافظة الغربية، مصر"
  },
  homeVisitRequest: {
    title: "طلب زيارة منزلية",
    subtitle: "املأ النموذج أدناه لطلب زيارة منزلية من فريقنا الطبي",
    form: {
      name: "الاسم",
      namePlaceholder: "أدخل اسمك الكامل",
      code: "الكود (إن وجد)",
      codePlaceholder: "أدخل الكود إن وجد",
      phone1: "رقم الهاتف 1",
      phone2: "رقم الهاتف 2 (إن وجد)",
      phonePlaceholder: "أدخل رقم الهاتف",
      age: "العمر",
      agePlaceholder: "اختر العمر",
      tests: "اكتب التحاليل المطلوبة",
      testsPlaceholder: "اكتب قائمة بالتحاليل المطلوبة",
      prescription: "رفع صورة الروشته",
      uploadPrescription: "انقر لرفع صورة الروشته",
      preferredDate: "التاريخ المفضل",
      preferredTime: "الوقت المفضل",
      address: "العنوان بالتفصيل",
      addressPlaceholder: "أدخل العنوان بالتفصيل",
      submit: "إرسال الطلب",
      submitting: "جاري الإرسال..."
    },
    errors: {
      nameRequired: "الاسم مطلوب",
      phoneRequired: "رقم الهاتف مطلوب",
      phoneInvalid: "صيغة رقم الهاتف غير صحيحة",
      ageRequired: "العمر مطلوب",
      addressRequired: "العنوان مطلوب"
    },
    successMessage: "تم إرسال طلبك بنجاح! سنتواصل معك قريباً."
  }
};

export default contentAr;

